import style from './assignEmp.module.scss';
import PropTypes from 'prop-types';
import cn from 'classnames';
import SearchIcon from '@assets/images/Fireboard/Search';
import { ReactComponent as Table } from '@assets/images/table.svg';
import { ReactComponent as Profile } from '@assets/images/profileFb.svg';
import { ReactComponent as Dash } from '@assets/images/minusLarge.svg';
import Header from './header';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const TableCard = ({
  table,
  activeTable,
  setActiveTable,
  onDeleteTable,
  revenueCenters,
}) => {
  const { employees, station } = table;
  const { name, number, revenueCenterId } = station;

  const revenueCenterName = revenueCenters.find(
    item => item?.id === revenueCenterId
  )?.name;

  const active = station?.id === activeTable?.station?.id;
  return (
    <div
      className={cn(style.employeeCard, active ? style.activeClass : '')}
      onClick={() => setActiveTable(table)}
    >
      <div className="d-flex">
        <div className={cn(style.primaryDiplayIcon, 'pr-2')}>
          <Table />
        </div>

        <div className={style.info}>
          <div className="pb-2">{name || number}</div>
          <div className={style.secondaryText}>{revenueCenterName}</div>
        </div>
      </div>

      <div className={cn('overflow-auto d-flex mr-3 w-100')}>
        {employees.map(employee => {
          const empName = `${employee?.firstName ?? ''} ${employee?.lastName ??
            ''}`.trim();
          const employeeName = empName !== '' ? empName : employee?.posId;

          return (
            <div key={employee?.id} className={style.employeeNameTag}>
              <span>{employeeName}</span>
            </div>
          );
        })}
      </div>
      {employees?.length > 0 && (
        <div
          className={style.fill}
          onClick={() => onDeleteTable(employees[0], station)}
        >
          <Dash />
        </div>
      )}
    </div>
  );
};

const TableView = props => {
  const {
    activeTab,
    setActiveTab,
    searchEmpval,
    setSearchEmpval,
    filteredData,
    activeTable,
    setActiveTable,
    onFilterChange,
    onDeleteTable,
    revenueCenters,
    filteredEmpData,
    setTableSearchVal,
    tableSearchVal,
    setSelectedEmp,
    selectedEmp,
    onAssignEmp,
  } = props;

  const onSearchTable = event => {
    setTableSearchVal(event);
  };

  const getSelectedStyles = (active, table) => {
    if (active && !table) {
      return `${style.tableCard} ${style.activeClass}`;
    } else if (table && !active) {
      return `${style.activeClasses}`;
    } else if (active && table) {
      return `${style.borderWhite} ${style.activeClasses}`;
    } else {
      return style.tableCard;
    }
  };

  return (
    <>
      <div className={cn(style.contentWrapper, 'p-3')}>
        <div className="row h-100">
          <div className="col-7 pl-0 pt-3">
            <div className={style.header}>
              {FLABEL().ASSIGN_EMPLOYEE_TABLES}
            </div>
            <Header
              setActiveTab={setActiveTab}
              activeTab={activeTab}
              onSearch={e => onSearchTable(e)}
              searchEmpval={tableSearchVal}
              setSearchEmpval={setTableSearchVal}
              onFilterChange={val => onFilterChange(val)}
            />
            <div className={style.employeeTable}>
              {filteredData?.length > 0 ? filteredData?.map(table => {
                return (
                  <TableCard
                    table={table}
                    activeTable={activeTable}
                    setActiveTable={setActiveTable}
                    onFilterChange={onFilterChange}
                    onDeleteTable={onDeleteTable}
                    revenueCenters={revenueCenters}
                  />
                );
              }) : 
              <div className='d-flex justify-content-center align-items-center h-100'>
                {FLABEL().ASSIGN_EMPLOYEE_NO_TABLES}
              </div>
              }
            </div>
          </div>

          <div className={cn('col-5 p-3', style.tableBg)}>
            <div className={style.header}>
              {FLABEL().ASSIGN_EMPLOYEE_EMPLOYEES}
            </div>
            <div className="my-3">
              <form className="position-relative">
                <input
                  type="text"
                  placeholder={FLABEL().ASSIGN_EMPLOYEE_SEARCH}
                  className={cn(style.searchInput2, 'col-12 pl-3 pr-5')}
                  value={searchEmpval}
                  onChange={e => setSearchEmpval(e.target.value)}
                />
                <div className={style.searchIcon}>
                  <SearchIcon />
                </div>
              </form>
            </div>
            <div className={cn('overflow-y-auto', filteredEmpData?.length > 0 ? style.tablesWrapper : style.noData)}>
              {filteredEmpData?.length > 0 ? (
                filteredEmpData?.map(empData => {
                  const { employee } = empData;
                  const isTableAssigned =
                    Array.isArray(empData.stations) &&
                    empData.stations.length > 0;
                  const active = selectedEmp?.id === employee.id;

                  return (
                    <div
                      key={employee.id}
                      className={cn(
                        style.employeeCard_tableView,
                        getSelectedStyles(active, isTableAssigned)
                      )}
                      onClick={() => setSelectedEmp(employee)}
                    >
                      <div
                        className={cn(
                          'd-flex align-items-center justify-content-center',
                          style.profile_tableview
                        )}
                      >
                        <Profile
                          style={`color:${isTableAssigned} ? '#96aeff' : '#fff'`}
                        />
                      </div>
                      <div
                        className={cn(
                          style.secondaryText,
                          'w-100 mt-1 mb-1 text-truncate text-center'
                        )}
                      >
                        {`${employee?.firstName ?? ''} ${employee?.lastName ??
                          ''}`}
                      </div>
                      <div
                        className={cn(
                          style.secondaryText,
                          'w-100 text-truncate text-center'
                        )}
                      >
                        {employee?.posId ?? ''}
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="fs-12 d-flex justify-content-center align-items-center text-center">
                  {FLABEL().ASSIGN_EMPLOYEE_NO_EMPLOYEES}
                </div>
              )}
            </div>
            <button
              className={cn(
                selectedEmp ? style.assign : style.assignDisable,
                'w-100 mt-3'
              )}
              onClick={() => onAssignEmp(selectedEmp)}
            >
              {FLABEL().ASSIGN_EMPLOYEE_ASSIGN}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

const EmployeeShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  posId: PropTypes.string,
});

const StationShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  revenueCenterId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

const TableShape = PropTypes.shape({
  station: StationShape,
  employees: PropTypes.arrayOf(EmployeeShape),
});

TableCard.propTypes = {
  table: TableShape,
  activeTable: TableShape,
  setActiveTable: PropTypes.func,
  onDeleteTable: PropTypes.func,
  revenueCenters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
    })
  ),
};

TableView.propTypes = {
  activeTab: PropTypes.string,
  setActiveTab: PropTypes.func,
  searchEmpval: PropTypes.string,
  setSearchEmpval: PropTypes.func,
  tableSearchVal: PropTypes.string,
  setTableSearchVal: PropTypes.func,
  filteredData: PropTypes.arrayOf(TableShape),
  activeTable: TableShape,
  setActiveTable: PropTypes.func,
  onFilterChange: PropTypes.func,
  onDeleteTable: PropTypes.func,
  revenueCenters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
    })
  ),
  filteredEmpData: PropTypes.arrayOf(
    PropTypes.shape({
      employee: EmployeeShape,
      stations: PropTypes.array,
    })
  ),
  selectedEmp: EmployeeShape,
  setSelectedEmp: PropTypes.func,
  onAssignEmp: PropTypes.func,
};

TableView.defaultProps = {
  activeTab: '',
  searchEmpval: '',
  tableSearchVal: '',
  filteredData: [],
  filteredEmpData: [],
  revenueCenters: [],
  activeTable: null,
  selectedEmp: null,
  setActiveTab: () => {},
  setSearchEmpval: () => {},
  setTableSearchVal: () => {},
  setActiveTable: () => {},
  setSelectedEmp: () => {},
  onFilterChange: () => {},
  onDeleteTable: () => {},
  onAssignEmp: () => {},
};

TableCard.defaultProps = {
  table: {
    station: {},
    employees: [],
  },
  activeTable: null,
  setActiveTable: () => {},
  onDeleteTable: () => {},
  revenueCenters: [],
};
export default TableView;
